// extracted by mini-css-extract-plugin
export default {"valueProp":"valueProp__YjQ1N","hed":"hed__OGExM","icon":"icon__MzEwZ","list":"list__M2YxY","promoTag":"promoTag__YmRmY","promoText":"promoText__NDZmN"};